import * as React from "react";
import { ChevronDown } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Bloc repliable natif (<details>/<summary>).
 *
 * Contrairement à l'accordéon Radix, aucune mesure de hauteur n'est effectuée
 * en JavaScript : pas de reflow forcé au montage, et le contenu est présent
 * dans le HTML servi (utile pour le crawl).
 */
export interface DisclosureProps extends React.ComponentPropsWithoutRef<"details"> {
  summary: React.ReactNode;
  summaryClassName?: string;
  contentClassName?: string;
}

export const Disclosure = React.forwardRef<HTMLDetailsElement, DisclosureProps>(
  ({ summary, summaryClassName, contentClassName, className, children, ...props }, ref) => (
    <details ref={ref} className={cn("group border-b", className)} {...props}>
      <summary
        className={cn(
          "flex cursor-pointer list-none items-center justify-between gap-3 py-4 font-medium hover:underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary [&::-webkit-details-marker]:hidden",
          summaryClassName,
        )}
      >
        {summary}
        <ChevronDown
          className="h-4 w-4 shrink-0 transition-transform duration-200 group-open:rotate-180"
          aria-hidden="true"
        />
      </summary>
      <div className={cn("pb-4 pt-0 text-sm", contentClassName)}>{children}</div>
    </details>
  ),
);
Disclosure.displayName = "Disclosure";

export default Disclosure;
